module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('side-bar-info'), _vm._v(" "), _c('document'), _vm._v(" "), _c('document-footer'), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "helpModal",
      "header": _vm.$t('functional.help')
    },
    scopedSlots: _vm._u([{
      key: "modalButtons",
      fn: function(props) {
        return [_c('app-button', {
          attrs: {
            "text": _vm.$t('functional.close'),
            "iconName": "times",
            "action": props.close
          }
        })]
      }
    }])
  }, [_c('help')], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "rejectModal",
      "header": _vm.$t('functional.rejectEnvelope')
    },
    scopedSlots: _vm._u([{
      key: "modalButtons",
      fn: function(props) {
        return [_c('app-button', {
          attrs: {
            "text": _vm.$t('functional.close'),
            "iconName": "times",
            "action": props.close
          }
        }), _vm._v(" "), _c('app-button', {
          attrs: {
            "text": _vm.$t('functional.reject'),
            "iconName": "trash",
            "action": _vm.rejectDocument,
            "classList": "float-right button--cancel"
          }
        })]
      }
    }])
  }, [_c('reject-document')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c14f05e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Index.vue
// module id = 1043
// module chunks = 1